import { createFileRoute } from '@tanstack/react-router';
import { AdminLayout } from '@/components';

export const Route = createFileRoute('/_adminLayout')({
  component: AdminLayout
});
